/**
 * Logo
 */
 import logo from '../../assets/logo/bolt-logo-no-text.svg';
 import main_logo from "../../assets/logo/main-logo.png";
 
 /**
  * Background
  */

import * as THEME from '../../assets/theme/color'
 
  
 /**
  * Color Theme
  */
const ThemeColor = THEME.color
const ThemeText = THEME.text
 
const img = {
     logo: logo,
     main: main_logo
}
 
const color = {
     themeColor: ThemeColor,
     themeText: ThemeText
}
 
export const LOGO = img.logo;
export const MAIN_LOGO = img.main
 
export const THEME_COLOR = color.themeColor;
export const TEXT_COLOUR = color.themeText;